import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  iconLink: {
    minWidth: '20px',
    cursor: 'pointer'
  }
}));
